module.exports = __webpack_public_path__ + "assets/img/al5.752d17b9.jpg";